<template>
  <loan-list
    filter="Pawn"
    :title="$t('menu.pawnLoan')"
  />
</template>

<script>
import LoanList from './List'

export default {
  name: 'PawnLoanList',
  metaInfo () {
    return {
      title: this.$t('menu.pawnLoan'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { LoanList }
}
</script>

<style scoped>

</style>
